import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3df2b09a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "text-center my-8" }
const _hoisted_3 = {
  key: 0,
  class: "text-black-light-2 text-center my-6"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "my-3"
}
const _hoisted_6 = {
  key: 3,
  class: "text-black-light-2 text-center my-3"
}
const _hoisted_7 = { key: 4 }
const _hoisted_8 = {
  key: 5,
  class: "my-3",
  style: {"margin-left":"-30px"}
}
const _hoisted_9 = {
  key: 6,
  class: "my-3",
  style: {"margin-left":"-30px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "d-flex justify-center area-btns mt-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Sim", -1))

import { withDefaults, ref, computed } from 'vue';
import { IOptionsSelect } from '@/types';
import { MoleculeModal } from '.'
import * as comps from '@/components/atoms';
import { AtomSelect } from '../atoms';
import AtomCheckBox from '../atoms/AtomCheckBox.vue';

interface IProps {
  icon?: string
  text?: string
  description?: string
  iconColor?: string
  showAlertConfirm: boolean;
  isText?: boolean
  label?: string,
  width?: number
  canDuplicate?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModalAlert',
  props: {
    icon: {},
    text: {},
    description: {},
    iconColor: {},
    showAlertConfirm: { type: Boolean },
    isText: { type: Boolean, default: false },
    label: {},
    width: { default: 320 },
    canDuplicate: { type: Boolean, default: true }
  },
  emits: ['cancel', 'confirm'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const reason = ref<string>('');
const emit = __emit;

const end_date = ref<Date>(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));

const dateComputed = computed(() => {
    return [
      {
        text: new Date(new Date().getFullYear(), new Date().getMonth(), 0).toLocaleString('default', { month: 'long' }),
        value: new Date(new Date().getFullYear(), new Date().getMonth(), 0)
      } as IOptionsSelect,
      {
        text: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toLocaleString('default', { month: 'long' }),
        value: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      } as IOptionsSelect
    ];
});

const skip = ref<boolean>(false);
const copy_goal = ref<boolean>(false);  

function handleCancel() {
  emit('cancel')
}

function handleConfirm() {
  emit('confirm', { reason, end_date, skip, copy_goal })
}

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    "padding-y": "32px",
    width: props.width.toString(),
    onHandleCancel: handleCancel,
    title: "Logout",
    showHeader: false,
    showFooter: false,
    persistent: false,
    show: _ctx.showAlertConfirm,
    "btn-close-text": "Cancelar"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          (props.icon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.icon]), {
                key: 0,
                color: props.iconColor
              }, null, 8, ["color"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(props.text), 1)
        ]),
        (props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.description), 1))
          : _createCommentVNode("", true),
        (props.isText)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_4))
          : _createCommentVNode("", true),
        (props.isText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
              _createVNode(_unref(AtomSelect), {
                label: "Mês de Encerramento",
                placeholder: "Escolha o mês de encerramento",
                options: dateComputed.value,
                modelValue: end_date.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((end_date).value = $event))
              }, null, 8, ["options", "modelValue"])
            ]))
          : _createCommentVNode("", true),
        (props.isText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createVNode(_component_v_textarea, {
                label: props.label,
                modelValue: reason.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reason).value = $event))
              }, null, 8, ["label", "modelValue"])
            ]))
          : _createCommentVNode("", true),
        (props.isText)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_7))
          : _createCommentVNode("", true),
        (props.isText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createVNode(AtomCheckBox, {
                label: "Marque para NÃO considerar essa meta na “Calculadora”",
                placeholder: "Marque para NÃO considerar essa meta na “Calculadora”",
                modelValue: skip.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((skip).value = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (props.isText && props.canDuplicate)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
              _createVNode(AtomCheckBox, {
                label: "Criar nova meta à partir desta (copiar as configurações desta meta para criar uma nova)",
                placeholder: "Criar nova meta à partir desta (copiar as configurações desta meta para criar uma nova)",
                modelValue: copy_goal.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((copy_goal).value = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(comps.AtomButton, {
            background: "transparent",
            outlined: "",
            noHover: "",
            onClick: handleCancel,
            class: "btn-actions btn-back-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Voltar ")
            ]),
            _: 1
          }),
          _createVNode(comps.AtomButton, {
            onClick: handleConfirm,
            class: "btn-actions",
            disabled: props.isText && !reason.value
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["width", "show"]))
}
}

})